/*
 * @Author: ningbo.kang
 * @Date: 2019-05-29 09:31:34
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-12-20 11:31:22
 * @Description: 用户登录-接口
 */
import qs from 'qs';
import db from '@/api/db';
import dbGateway from '@/api/dbGateway';

/**
 * [model 用户管理模块]
 * @type {Object}
 */
const model = {
  // begin: 获取验证码
  /**
   * 获取验证码随机身份 key
   */
  getKey() {
    return db.post('/pageInit');
  },
  /**
   * 根据身份key，获取对应的图片验证码
   * @param {Object} param
   */
  getCode(param) {
    return db.get('/verificationCode', param);
  },
  // end: 验证码

  /**
   * 用户登录
   * @param {*} param
   */
  login(param) {
    return db.post('/login', qs.stringify(param));
  },
  /**
   *  设置语言
   */
  setlang(param) {
    if (process.env.VUE_APP_PREVIEW === 'true') {
      return db.get('/lang', param);
    }
    return db.get('/', param);
  },
  // SSO登录
  SSOCode2Token(params) {
    return db.get('/codeCallback', params);
  },

  /**
   * 获取用户信息
   * @param {*} param
   */
  getInfo(param) {
    return dbGateway.get('/gateway/account/current', param);
  },

  /**
   * 注销登录状态
   */
  logout() {
    return dbGateway.post(`/gateway/auth/logout?clientId=${process.env.VUE_APP_CLIENT_ID}`);
  },

  /**
   *  刷新心跳，服务端暂未实现
   */
  healthCheckStatus() {
    return db.get('/user/health');
  },
  getInterConfig() {
    return dbGateway.get('/mdm-client/api/sys/message/all');
  },
  // 获取飞书认证信息
  getLarkInfo(param) {
    return db.get(
      `${process.env.VUE_APP_API_BASE_URL_GATEWAY}/lark-oauth-server/lark/jsapi/user/ticket`,
      param
    );
  }

};

export default model;
